<template>
  <div class="subpage main_area" style="position: relative">
    <div class="layout mainpage fullpage_white slot_game_subpage" style="overflow-x: hidden">
   
      <hr class="line_slotlist" />
      <div class="slot_games_lists" v-if="gamecode == 'obgdy'">
        <div class="block_rows" v-for="(item, index) in obgdyList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <img :src="item.gamepic" />
          <div class="vgc_name">{{ item.gamename }}</div>
        </div>
      </div>
      <div class="slot_games_lists" v-if="gamecode == 'fgdz'">
        <div class="block_rows" v-for="(item, index) in fgdzList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <img :src="item.gamepic" />
          <div class="vgc_name">{{ item.gamename }}</div>
        </div>
      </div>
      <div class="slot_games_lists" v-if="gamecode == 'pp'">
        <div class="block_rows" v-for="(item, index) in ppList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <img :src="item.gamepic" />
          <div class="vgc_name">{{ item.gamename }}</div>
        </div>
      </div>
      <div class="slot_games_lists" v-if="gamecode == 'ae'">
        <div class="block_rows" v-for="(item, index) in aeList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <img :src="item.gamepic" />
          <div class="vgc_name">{{ item.gamename }}</div>
        </div>
      </div>
        <div class="slot_games_lists" v-if="gamecode == 'pg'">
        <div class="block_rows" v-for="(item, index) in pgList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <img :src="item.gamepic" />
          <div class="vgc_name">{{ item.gamename }}</div>
        </div>
      </div>
        <div class="slot_games_lists" v-if="gamecode == 'fgfish'">
        <div class="block_rows" v-for="(item, index) in fgfishList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <img :src="item.gamepic" />
          <div class="vgc_name">{{ item.gamename }}</div>
        </div>
      </div>
      <div id="goTop"><img src="https://7148ssss.com/m/templateimage/slots/gotop.png" /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'electronics',
  data() {
    return {
      aeList: [],
      ppList: [],
      fgdzList: [],
      obgdyList: [],
      pgList: [],
      fgfishList: [],
      gamecode: 'obgdy',
    };
  },
  created() {
    let that = this;
    if (this.$route.query) {
      that.gamecode = this.$route.query.type || that.gamecode;
    }
    that.gamelistBycode();
  },
  methods: {
    changgamecode(code) {
      let that = this;
      if (code == that.gamecode) {
        return;
      }

      that.gamecode = code;

      that.gamelistBycode();
    },
    gamelistBycode() {
      let that = this;
      let name = that.gamecode + 'List';
      if (that[name].length > 0) {
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/gamelistBycode', { gamecode: that.gamecode })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that[name] = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        let query = this.$route.query;
        if (query.type) {
          that.gamecode = query.type;
          that.gamelistBycode();
        }
      },
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.slot_games_lists {
  display: flex;
  flex-wrap: wrap;
}
.slot_games_lists .block_rows {
  width: 33%;
  height: 138px;
  margin-top: 10px;
}
.slot_games_lists .block_rows img {
  width: 90%;
  display: block;
  margin: 0 auto;
  max-height: 112px;
}
.slot_games_lists .block_rows .vgc_name {
  text-align: center;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/electronics.vue